import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const PortablePage = () => (
  <Layout>
    <SEO title="Mesin Kasir Portable" />
    <div class="masthead-followup row m-3">
<div class="col-12 col-md-12 p-3 p-md-5 bg-white text-center">
  <h1><strong><a title="new mesin kasir portable" href="/portable">PORTABLE</a></strong></h1>
  <h2>New portable generation point of sale technology.</h2>
  <div class="embed-responsive embed-responsive-16by9">
  <iframe title="mesin kasir tablet pos" class="rounded shadow" width="560" height="315" src="https://www.youtube.com/embed/cRKPNLRBTFU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
    <p>Mesin Kasir portable adalah sebuah technology mesin kasir yang dalam operasionalnya tanpa mengguakan aliran listrik dalam bekerja hal ini mengapa disebut dengan mesin kasir portable.</p>
<img alt="mesin kasir murah" width="100%" class="img-fluid shadow" src="./img/mesin kasir online murah.jpg"/>
<p><a title="new mesin kasir portable" href="/portable">Mesin kasir portable</a> memudahkan dalam setiap transaksi semakin ringkas dengan penggunaan printer bluetooth dalam kebutuhan nya,mengadopsi windows tablet agar lebih superior dan kuat awet tahan lama adalah pilihan utama.</p>
<img alt="mesin kasir murah terbaru" width="100%" class="img-fluid shadow" src="./img/mesin kasir murah terbaru.jpg"/>
<p>Dengan portable system system semkin ringkas dan tanpa aliran listrik menjadikan simple nya system ini untuk digunakan menunjang usaha mu, mudah kompleks menjadikan mu lebih mobile dengan portable system nya.</p>
<img alt="mesin kasir printer kasir" width="100%" class="img-fluid shadow" src="./img/printer kasir.jpg"/>
<p>Dukungan printer kasir semakin memudahkan dalam proses transaksi dengan metode cetak struk kasir dalam penggunaan nya,tersedia beberapa printer kasir untuk kebutuhan mulai dari mini 58mm hingga 80mm sesuai type paket mesin kasir murah set.</p>
<img alt="mesin kasir murah terbaik" width="100%" class="img-fluid shadow" src="./img/Cash-Register-ipad-POS-Cash-Drawer.jpg"/>
<p>Optional untuk melengkapi mesin kasir murah set maka kebutuhan akan laci kasir cash drawer sangat membantu untuk mempercantik tatanan display mesin kasir hingga kebutuhan sebagai mediasi uang transaksi kasir.</p>
<img alt="paket mesin kasir set lengkap" width="100%" class="img-fluid shadow" src="./img/mesinkasirmurah (11).jpg"/>
<p>All in one terintegrasi dengan baik dan free installasi setting siap pakai untuk menunjang kebutuhan usaha mu.</p>
<p>Back to <Link to="/">Home Page</Link></p>
</div></div>
  </Layout>
)

export default PortablePage
